'use client';
//import * as motion from 'framer-motion/client';
import styles from './hero.module.scss';
import Image from 'next/image';
import classNames from 'classnames';
import { useScroll, useTransform, motion } from 'framer-motion';
import T from '../../../common/components/T';
import { navigateV2 } from '../../../common/utils/router';
//import { useContext } from 'react';
//import UserContext from '../../../common/utils/getContext';
import uikit from '../../../project/uikit/uikit.module.scss';

const HeroPage = ({ isUserToken }) => {
    const { scrollY } = useScroll();
    const changeScale = useTransform(scrollY, [0, 720], [1, 0.8]);
    const changeY = useTransform(scrollY, [0, 720], ['0px', '-100px']);
    return (
        <div className={classNames(styles.mainWrapper, styles.mainWrapperHero)} id='#section1'>
            <motion.div style={{ y: changeY }} className={styles.mainContentBlock}>
                <div className={classNames(uikit.container)}>
                    <motion.div style={{ scale: changeScale }}>
                        <div className={styles.textWrapper}>
                            <div className={styles.textBlock}>
                                <motion.h1
                                    initial={{ y: '100%' }}
                                    animate={{ y: 0 }}
                                    transition={{ delay: 0, duration: 0.5, ease: 'linear' }}
                                    className={styles.heroText}
                                >
                                    <T textName={'landing-hero-newtitle1'} defaultStr={'Задаем тренды,'} page='/' />
                                </motion.h1>
                            </div>
                            <div className={styles.textBlock}>
                                <motion.h1
                                    initial={{ y: '100%' }}
                                    animate={{ y: 0 }}
                                    transition={{ delay: 0.5, duration: 0.5, ease: 'linear' }}
                                    className={classNames(styles.heroText, styles.heroTextSecond)}
                                >
                                    <T textName={'landing-hero-newtitle2'} defaultStr={'меняем мир'} page='/' />
                                </motion.h1>
                            </div>
                        </div>
                        <div className={styles.descriptionBlock}>
                            <motion.div
                                initial={{ y: '100%' }}
                                animate={{ y: 0 }}
                                transition={{ delay: 0.5, duration: 0.5, ease: 'linear' }}
                                className={styles.heroDescription}
                            >
                                <T
                                    textName={'landing-hero-newdescription1'}
                                    defaultStr={'Станьте частью глобального успеха'}
                                    page='/'
                                />
                            </motion.div>
                        </div>
                    </motion.div>
                    <div className={styles.buttonBlock}>
                        <motion.button
                            initial={{ y: '100%' }}
                            animate={{ y: 0 }}
                            transition={{ delay: 0.5, duration: 0.5, ease: 'linear' }}
                            className={styles.heroButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (isUserToken) {
                                    navigateV2('/office');
                                } else {
                                    navigateV2('/auth/register');
                                }
                            }}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                if (isUserToken) {
                                    window.open('/office', '_blank');
                                } else {
                                    window.open('/auth/register', '_blank');
                                }
                            }}
                        >
                            <T textName={'landing-hero-newbutton1'} defaultStr={'Узнать больше'} page='/' />
                        </motion.button>
                    </div>
                </div>
            </motion.div>
            <div className={styles.mainWrapperHeroDecor}>
                <motion.div
                    initial={{ x: '-100%', y: '-100%' }}
                    animate={{ x: 0, y: 0 }}
                    transition={{ delay: 0.5, duration: 1, ease: 'linear' }}
                    className={styles.ellips1Wrapper}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon1' width={220} height={220} />
                </motion.div>
                <motion.div
                    initial={{ y: '-130%' }}
                    animate={{ y: 0 }}
                    transition={{ delay: 0.5, duration: 1, ease: 'linear' }}
                    className={styles.ellips2Wrapper}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon2' width={220} height={220} />
                </motion.div>
                <motion.div
                    initial={{ y: '-130%', x: '50%' }}
                    animate={{ y: 0, x: 0 }}
                    transition={{ delay: 0.75, duration: 1, ease: 'linear' }}
                    className={styles.ellips3Wrapper}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon3' width={220} height={220} />
                </motion.div>
                <motion.div
                    initial={{ x: '100%' }}
                    animate={{ x: 0 }}
                    transition={{ delay: 0.5, duration: 1, ease: 'linear' }}
                    className={styles.ellips4Wrapper}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon4' width={268} height={268} />
                </motion.div>

                <motion.div
                    initial={{ x: '3%', y: '240%' }}
                    animate={{ x: 0, y: 0 }}
                    transition={{ delay: 0.5, duration: 1, ease: 'linear' }}
                    className={styles.ellips6Wrapper}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon6' width={220} height={220} />
                </motion.div>
                <motion.div
                    initial={{ x: '20%', y: '140%' }}
                    animate={{ x: 0, y: 0 }}
                    transition={{ delay: 0.5, duration: 1, ease: 'linear' }}
                    className={styles.ellips5Wrapper}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon5' width={377} height={377} />
                </motion.div>
            </div>
        </div>
    );
};
export default HeroPage;
